import React from 'react';
import { Link } from 'react-router-dom';
import { Info } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

/**
 * Placeholder shown when a page isn't applicable to the current user.
 * E.g., Flight & Hotel page when not assigned to a trip.
 */
const NotApplicable = ({ title, message, linkTo, linkLabel }) => (
  <Card className="text-center py-12">
    <CardContent>
      <Info className="w-10 h-10 text-slate-300 mx-auto mb-3" />
      <p className="text-slate-500 font-medium">{title || 'Not Applicable'}</p>
      <p className="text-sm text-slate-400 mt-1 max-w-sm mx-auto">{message || 'This section will become available when you are assigned to a trip.'}</p>
      {linkTo && (
        <Link to={linkTo} className="inline-block mt-4">
          <Button variant="outline" className="rounded-full">{linkLabel || 'Back to Dashboard'}</Button>
        </Link>
      )}
    </CardContent>
  </Card>
);

export default NotApplicable;
